module.exports = __webpack_public_path__ + "img/3919d5715690fa956ec67101671bf71f.png";